import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class CvePocTaskAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'cvepoctask';

}

export default new CvePocTaskAPI();
